module.exports = __webpack_public_path__ + "img/inova-moda.bfcca41c.jpg";